<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col md="6">
        <b-card title="Request a Password Reset" v-if="state === 'ready'">
          <b-form v-on:submit.prevent.stop="submit">
            <p>
              If you have a Vos Voco account but have forgotten your password, please enter your email address
              below and we'll send you instructions to reset your password.
            </p>
            <b-form-group id="email_label" label="Email Address" label-for="email">
              <b-input id="email" type="email" v-model="email" required></b-input>
              <b-form-text>Please check carefully that you correctly enter the email address you use to log in to My Vos Voco.</b-form-text>
            </b-form-group>
            <b-alert variant="danger" :show="errorMessage != null">{{errorMessage}}</b-alert>
            <div class="text-right">
              <b-button :to="loginRoute">Cancel</b-button>
              <b-button type="submit" variant="primary">Submit</b-button>
            </div>
          </b-form>
          </b-form>
        </b-card>
        <b-card header="Thank You" v-else="true">
          <p class="card-text">
            We have sent you an email with instructions on resetting your password. If you do not receive your email within 2 hours,
            please <a href="mailto:info@vosvoco.com">contact us</a> for assistance.
          </p>
          <p class="text-right">
            <router-link :to="loginRoute" class="btn btn-secondary">Log in</router-link>
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import API from '@/lib/api'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      state: 'ready',
      errorMessage: null
    }
  },
  props: {
    oauth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    breadcrumbs () {
      if (this.oauth) {
        return [
          { text: 'Log In', to: this.loginRoute },
          { text: 'Forgot Password', to: {name: 'OauthForgotPassword', query: this.$route.query}, active: true }
        ]
      } else {
        return [
          { text: 'Log In', to: this.loginRoute },
          { text: 'Forgot Password', to: '/account/password/forgot', active: true }
        ]
      }
    },
    loginRoute () {
      if (this.oauth) {
        return {name: 'OauthLogin', query: this.$route.query}
      } else {
        return {name: 'Login'}
      }
    }
  },
  methods: {
    submit () {
      this.errorMessage = null
      API.post('account/password_reset', {
        email: this.email
      })
        .then((response) => {
          if (response.data != null) {
            this.state = 'complete'
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errorMessage = error.response.data.message
          } else {
            this.errorMessage = 'Cannot contact the Vos Voco servers. Please check your network connection and try again.'
          }
          console.log(error)
        })
      console.log('submit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue